module.exports = __webpack_public_path__ + "img/user-plus.f2964971.svg";